<template>
  <div class="statistic">
    <div class="statistic__title">
      {{$t('feed.analytics.statistics.title')}}
    </div>

    <el-card shadow="hover" class="statistic__card">
      <statistic-header chart-name="Statistic"/>

      <template v-if="!dataEmpty">
        <statistic-body
          :data="data"
          chart-name="Statistic"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.statistics.noData')}}.
      </template>

    </el-card>

    <div class="statistic__divider"></div>
  </div>
</template>

<script>
  /*
    Компонент статистики
    родительский Common
  */
// components
import StatisticHeader from "./header/StatisticHeader";
import StatisticBody from "./body/StatisticBody";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

import {
  TRUST_HOURLY, TRUST_DAILY
} from "../../../../../../../store/actions/analytics";

export default {
  name: "Statistic",
  data() {
    return {
      name: "Statistic"
    };
  },
  methods: {
    isRetro() {
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date()
        return condition
        //return [`${condition ? retrospective : this.localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : this.localPeriod[1].split(' ')[0]} 23:59:59`.replace(" ", "T")];
    },
  },
  mounted() {
    if (!this.isRetro)
      this.$store.dispatch(TRUST_HOURLY, {chart: this.name, thread: this.$route.params.threadId})
    else
      this.$store.dispatch(TRUST_DAILY, {chart: this.name, thread: this.$route.params.threadId});
  },
  mixins: [
    analytics
  ],
  components: {
    StatisticHeader,
    StatisticBody
  }
};
</script>

<style>
.statistic__title {
  margin-bottom: 20px;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: #5E6D82;
}

.statistic__card {
  margin-bottom: 20px;
}

.statistic__divider {
  border: 1px solid rgba(229, 229, 229, 0.5);
  margin-bottom: 33px;
}
@media screen and (max-width: 480px) {
  .statistic__card {
    overflow-x: auto;
  }
}
</style>
